import { gql } from '@apollo/client';

const GET_POSTS = gql`
  query getPosts($id: ID, $feedType: String!) {
    posts(id: $id, feedType: $feedType) {
      id
      content
      userId
      likes
      comments {
        id
        content
        createdAt
        userId
        postId
        replies {
          id
          content
          createdAt
          userId
          postId
          commentId
        }
      }
      createdAt
      imageUrl
    }
  }
`;

const GET_USER_POSTS = gql`
  query getUserPosts($id: ID!) {
    userPosts(id: $id) {
      id
      content
      userId
      likes
      comments {
        id
        content
        createdAt
        userId
        postId
        replies {
          id
          content
          createdAt
          userId
          postId
          commentId
        }
      }
      createdAt
      imageUrl
    }
  }
`;

const GET_POST = gql`
  query getPost($id: ID!) {
    post(id: $id) {
      id
      content
      userId
      likes
      comments {
        id
        content
        createdAt
        userId
        postId
        replies {
          id
          content
          createdAt
          userId
          postId
          commentId
        }
      }
      createdAt
      imageUrl
    }
  }
`;

export { GET_POSTS, GET_USER_POSTS, GET_POST }
